import MenuIcon from '@mui/icons-material/Menu';

import { ProfileSuccessResponse } from '../../api/authencation';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import CountUp from 'react-countup';
import { ASSETS } from '../../const/assets';
interface ChatHeaderProps {
  width: number;
  toggle: () => void;
  profile: ProfileSuccessResponse | undefined;
}

function ChatHeader({ width, toggle, profile }: ChatHeaderProps) {
  const previousCredit = useRef(profile?.credit || 0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    previousCredit.current = profile?.credit || 0;
  }, [profile?.credit]);

  return (
    <div className="border-[#ECECEC] border-b md:px-6 h-16 flex items-center px-2">
      {width === 0 && (
        <div onClick={toggle} className="mr-2">
          <MenuIcon className="cursor-pointer text-gray-600" />
        </div>
      )}
      <div className="flex items-center gap-4 bg-black h-11 rounded-xl px-3">
        <img
          src={
            parseInt(`${profile?.credit || '0'}`, 10) > 0
              ? ASSETS.icLogoAds
              : ASSETS.icLogoAds2
          }
          alt="icLogoAds"
          className="w-5 h-5 rounded-full"
          style={{
            boxShadow: `0px 0px 10px 0px ${
              parseInt(`${profile?.credit || '0'}`, 10) > 0
                ? '#FFFFFF'
                : '#141414'
            }`,
          }}
        />
        <span
          className={`text-base font-bold flex items-center gap-1 ${
            parseInt(`${profile?.credit || '0'}`, 10) > 0
              ? 'text-white'
              : 'text-[#FF7262]'
          }`}
        >
          <CountUp
            start={previousCredit.current}
            end={profile?.credit || 0}
            separator=","
            decimal="."
            decimals={0}
            duration={1}
            preserveValue={true}
            className="font-mono"
          />
        </span>
        <div
          className="flex items-center gap-2"
          onClick={() => setIsOpen(true)}
        >
          <img src={ASSETS.icInfo} alt="icInfo" className="cursor-pointer" />
        </div>
      </div>
      {isOpen && (
        <div className="z-50 gap-4 flex items-center bg-[#3C3C3C] p-4 w-[310px] rounded-lg flex-col fixed left-[250px] bottom-[80px] fade-in-up animate-fade-in-up">
          <img
            src={ASSETS.icClose}
            alt="icClose"
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-2 cursor-pointer"
          />
          <span className="font-bold text-base text-white">
            How To Get Credit
          </span>
          <div className="flex flex-col text-white justify-center items-center">
            <span>You can earn more Credits by watching </span>
            <span>Ads on our App.</span>
            <span>That how we keep this Free!</span>
          </div>
          <div className="flex items-center gap-2">
            <img src={ASSETS.icQr} alt="icQr" width={210} height={210} />
          </div>
          <div className="flex items-center gap-2">
            <img
              src={ASSETS.icAppstore}
              alt="icAppStore"
              className="cursor-pointer"
              onClick={() => {
                window.open(
                  `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`,
                  '_blank'
                );
              }}
            />
            <img
              src={ASSETS.icGooglePlay}
              alt="icGooglePlay"
              className="cursor-pointer"
              onClick={() => {
                window.open(
                  `https://apps.apple.com/us/app/aife-ai-for-everyone/id6739445777`,
                  '_blank'
                );
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatHeader;
